import { render } from "./ProjectsPanel.vue?vue&type=template&id=26460df2&scoped=true&ts=true"
import script from "./ProjectsPanel.vue?vue&type=script&lang=ts"
export * from "./ProjectsPanel.vue?vue&type=script&lang=ts"

import "./ProjectsPanel.vue?vue&type=style&index=0&id=26460df2&lang=scss&scoped=true"

import exportComponent from "/Users/otto/Code/projects/bubbly/doo/apps/builder-legacy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26460df2"]])

export default __exports__